module.exports = {
          srcSet: __webpack_public_path__ + "93fd5780.jpg"+" 700w"+","+__webpack_public_path__ + "e1d628e1.jpg"+" 1400w"+","+__webpack_public_path__ + "bfa13b0c.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "93fd5780.jpg",width: 700,height: 467},{path: __webpack_public_path__ + "e1d628e1.jpg",width: 1400,height: 933},{path: __webpack_public_path__ + "bfa13b0c.jpg",width: 2048,height: 1365}],
          src: __webpack_public_path__ + "93fd5780.jpg",
          toString:function(){return __webpack_public_path__ + "93fd5780.jpg"},
          
          width: 700,
          height: 467
        }